import { IAsset } from 'src/interfaces';

export interface ResourceSelectorSidebarProps {
  label: string;
  openResourceSelectorDrawer: boolean;
  onToggleResourceSelectorDrawer: () => void;
  onChange: (value: string) => void;
  error?: string | false;
  hasError?: boolean;
  type: ResourceType;
  defaultAssetName?: string;
}

export enum ResourceType {
  PRODUCT = 'PRODUCT',
  BACKGROUND = 'BACKGROUND',
}

export interface ResourceSelectorContentBodyProps {
  assets: IAsset[];
  searchVal: string;
  isLoadingAssets: boolean;
  onChangeSearchVal: (value: string) => void;
  selectedAssets: IAsset[];
  onSelectedAssets: (assets: IAsset[]) => void;
  type: string;
  onChange: (value: string) => void;
  defaultAsset?: IAsset;
}
